import React from 'react';
import PropTypes from 'prop-types';
import { detect } from 'detect-browser';
import { Container, Parent, ParallaxFallthrough } from '../styles/animated-element.style';
import { getViewport, generateImageUrl } from '../../../utils/webp';

/* eslint-disable */
const propTypes = {
  animationType: PropTypes.string,
  data: PropTypes.object,
};

const defaultProps = {
  animationType: '',
  data: {},
};

/**
 * Component that will animate whatever child is put inside of it
 * Hero Component
 * @param {object} params Incoming Params
 * @returns {XML} A new copyright component
 */
class AnimatedElement extends React.Component {
  /**
   *
   * @param {*} props Passed from parent component
   */
  constructor(props) {
    super(props);
    this.onScrollIn = this.onScrollIn.bind(this);
    this.state = {
      viewportWidth: 2400,
      retinaMultiplier: 1,
      browser: null,
    }
  }

  /**
   * Set viewport width on mount
   */
  componentDidMount() {
    const { scrollManager } = this.props;

    if (scrollManager) {
      scrollManager.addOnScrollIn(this.onScrollIn);
    }
    if (typeof window !== 'undefined' && window) {
      this.setState({
        viewportWidth: getViewport(),
        browser: detect(),
        retinaMultiplier: window.devicePixelRatio,
      });
    }
  }

  /**
   * Add scroll functions to scroll listener when component is on page
   * @param {object} prevProps props from before update
   */
  componentDidUpdate(prevProps) {
    const { scrollManager } = this.props;

    if (prevProps.scrollManager == null && scrollManager) {
      // scrollManager.addOnScroll(this.onScroll);
      scrollManager.addOnScrollIn(this.onScrollIn);
    }
  }

  /**
   * Callback for when element enters the view
   */
  onScrollIn() {
    const { animationType } = this.props;
  }

  /**
   *  Set element ref
   * @param {element} ele element reference
   */
  refCallback(ele) {
    this.ref = ele;
  }

  /**
   * Renders Component
   * @returns {*} component JSX
   */
  render() {
    const { animationType, data, children } = this.props;
    const { viewportWidth, browser, retinaMultiplier } = this.state;
    const width = Math.floor(Math.min(4000, viewportWidth * retinaMultiplier));
    let content = <Container>{children}</Container>;
    if (animationType.indexOf('PARALLAX') > -1) {
      let image = '';
      if (data && data.image && data.image.file && data.image.file.url) {
        image = generateImageUrl(data.image.file.url, width);
      }
      if (image === '') {
        content = (
          <div>
            {children}
          </div>
        )
      } else {
        if (!browser || (browser.name === 'ie' || browser.name === 'edge')) {
          content = (
            <Parent>
              <ParallaxFallthrough src={image}>
                {children}
              </ParallaxFallthrough>
            </Parent>
          );
        } else {
          const styleBg = {
            backgroundImage: `url(${image})`,
            backgroundPosition: 'center center',
            backgroundSize: 'cover'
          }
          content = (
            <Parent>
              <div style={styleBg}>
                {children}
              </div>
            </Parent>
          );
        }
      }
    }
    return <div ref={ele => this.refCallback(ele)}>{content}</div>;
  }
}

AnimatedElement.propTypes = propTypes;
AnimatedElement.defaultProps = defaultProps;

export default AnimatedElement;



// WEBPACK FOOTER //
// ./src/components/animated-element/components/animated-element.js